import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ScreenService } from '@ibe/services/ui';
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import * as fromStore from "../../../../store";
import { takeWhile, count } from "rxjs/operators";

import { INDRAAirportLocationService } from '@ibe.services/airport-location.indra.service';
import { SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_LANGUAGE, DEFAULT_MARKET } from '@ibe.config';
import { INDRABFMContinentsResponse, INDRABFMAirportsResponse } from '@ibe.models/airport.indra.model.lib';


@Component({
	selector: 'app-flight-explore-destinations',
	templateUrl: './flight-explore-destinations.indra.component.html',
	styleUrls: ['./flight-explore-destinations.component.scss']
})
export class INDRAFlightExploreDestinationsComponent implements OnInit, OnDestroy {

	searchRoute$: Observable<any> = this.store.select(fromStore.getMiniIBESearchRoutes);
	destinations: Array<{ label: any, value: any }>;
	totalDestinations = 0;
	selected_destinations;
	display_limit = 5;
	url = 'assets/images/plane.png';
	otherBookingTypes = [
		{
			id: 'rent-a-car',
			label: 'Rent-a-car',
			icon: 'icons.svg#services--rent_a_car',
			url: 'https://cars.flytap.com',
			aria: 'Open a new window to rent a car'
		},
		{
			id: 'transfer',
			label: 'Book a transfer',
			icon: 'icons.svg#transportation--bus',
			url: 'https://transport.flytap.com',
			aria: 'Open a new window to book a transfer'
		},
		{
			id: 'hotel',
			label: 'Book an hotel',
			icon: 'icons.svg#services--book_hotel',
			url: 'https://hotels.flytap.com',
			aria: 'Open a new window to book an hotel'
		},
		{
			id: 'parking',
			label: 'Parking',
			icon: 'icons.svg#services--parking',
			url: 'https://parking.flytap.com',
			aria: 'Open a new window to book a parking space'
		},
		{
			id: 'tours-and-activities',
			label: 'Tours & Activities',
			icon: 'icons.svg#destinations--tours_activities',
			url: 'http://atividades.flytap.com/',
			aria: 'Open a new window to search for tours and other activities'
		}
	];

	allOtherBookingTypes = {
		id: 'all-booking-options',
		label: 'All booking options',
		url: 'https://www.flytap.com/outras-reservas',
		aria: 'Open a new window to view all other booking options'
	};

	bestOffers = {
		location: {
			city: ''
		},
		offers: [
			{
				title: 'São Miguel',
				label: 'from 12 EUR',
				image: 'PDL'
			},
			{
				title: 'Barcelona',
				label: 'from 45 EUR',
				image: 'BCN'
			},
			{
				title: 'Paris',
				label: 'from 34 EUR',
				image: 'PAR'
			},
			{
				title: 'Rome',
				label: 'from 80 EUR',
				image: 'ROM'
			},
			{
				title: 'Marrakech',
				label: 'from 311 EUR',
				image: 'RAK'
			}
		]
	};

	block_flights_to_city = [
		{
			city: 'Europe',
			flights: [
				{ image: './assets/images/destinations/banner/AMS.jpg', city: 'Funchal', price: 12, type: 'roundtrip' },
				{ image: './assets/images/destinations/banner/BCN.jpg', city: 'Madrid', price: 12, type: 'oneway' },
				{ image: './assets/images/destinations/banner/CHI.jpg', city: 'Berlin', price: 12, type: 'roudntrip' },
				{ image: './assets/images/destinations/banner/FNC.jpg', city: 'Rome', price: 12, type: 'roudntrip' }
			]
		},
		{
			city: 'Noth America',
			flights: [
				{ image: './assets/images/destinations/banner/HAM.jpg', city: 'Boston', price: 12, type: 'roudntrip' },
				{ image: './assets/images/destinations/banner/LIS.jpg', city: 'Toronto', price: 12, type: 'oneway' },
				{ image: './assets/images/destinations/banner/MAD.jpg', city: 'Miami', price: 12, type: 'oneway' },
				{ image: './assets/images/destinations/banner/OPO.jpg', city: 'Prague', price: 12, type: 'roudntrip' }
			]
		},
		{
			city: 'South America',
			flights: [
				{ image: './assets/images/destinations/banner/PAR.jpg', city: 'Prague', price: 12, type: 'oneway' },
				{ image: './assets/images/destinations/banner/RIO.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
				{ image: './assets/images/destinations/banner/ROM.jpg', city: 'Prague', price: 12, type: 'oneway' },
				{ image: './assets/images/destinations/banner/SAO.jpg', city: 'Prague', price: 12, type: 'roudntrip' }
			]
		},
		{
			city: 'Africa',
			flights: [
				{ image: './assets/images/destinations/banner/MAD.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
				{ image: './assets/images/destinations/banner/LIS.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
				{ image: './assets/images/destinations/banner/HAM.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
				{ image: './assets/images/destinations/banner/AMS.jpg', city: 'Prague', price: 12, type: 'oneway' }
			]
		}
	];
	airportParams = {
		language: sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) : DEFAULT_LANGUAGE,
		market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET) : DEFAULT_MARKET,
		country: '',

	};

	continentsParams = {
		language: sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) : DEFAULT_LANGUAGE,
		market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET) : DEFAULT_MARKET,
	};

	continents = [];
	loading;

	isMobile: boolean = false;
	regions = [];
	selectedCountryCode = null;
	countries: Array<any> = [];
	newRegions: Array<any> = [];
	airports: Array<any> = [];
	places: any;
	isAlive = true;

	airportPromise: Promise<void>;
	continentPromise: Promise<void>;
	departure: any;
	airportCode: any;
	origin: any;
	getDestinationsFlag = false;
	previousAirportCode = '';
	region: [];
	airportsPerCountry: any[];
	
	private isScreenMobileTabletPortrait$: Observable<boolean> = this.store.select(fromStore.isScreenMobileTabletPortrait);
	isScreenMobileTabletPortrait: boolean;

	constructor(
		private sanitizer: DomSanitizer,
		private screen: ScreenService,
		private airportLocationService: INDRAAirportLocationService,
		private store: Store<fromStore.State>,
	) {

		this.isScreenMobileTabletPortrait$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isScreenMobileTabletPortrait = value;
			});
	}

	ngOnInit() {

		const continentsParams = Object.keys(this.continentsParams).map(key => key + '=' + this.continentsParams[key]).join('&');

		this.airportLocationService.INDRAGetContinents(continentsParams).toPromise().then(
			async (response: INDRABFMContinentsResponse) => {
				this.regions = [];
				this.countries = [];
				this.places = [];
				this.newRegions = [];
				if (response) {
					this.regions = response.Continents;
					if (this.regions) {
						for (let i = 0; i < this.regions.length; i++) {

							let region = {
								'label': this.regions[i].name,
								'value': this.regions[i].name,
								'code': this.regions[i].code
							};
							this.newRegions.push(region);
							region = null;
						}
						this.continents = this.newRegions;
						this.selected_destinations = this.continents[0].label;
						this.INDRA_setPutDestination(this.selected_destinations);
						this.destinations = this.continents;

					}
				}
				

			});
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_getPlaneImage() {
		const url = 'assets/images/plane.png';
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}
	
	// TODO: implement this to compute the total number of destinations/airports to display
	INDRA_setDestinationsCount() {
		//this.continents.forEach(continent => {
		//	continent.countrys.forEach(country => {
		//		this.totalDestinations += country.places.length;
		//	});
		//});
	}

	async INDRA_getCountrysDestinations() {
		const country_limit = this.display_limit;
		this.region = this.selected_destinations;
		const regionIdx = this.regions.findIndex(x => x.name === this.region);
		if (this.regions && this.regions[regionIdx].countries && this.regions[regionIdx].countries.length !== 0) {
			this.countries = [];
			for (let j = 0; j < country_limit; j++) {

				this.airportParams.country = this.regions[regionIdx].countries[j].code;
				const airportString = Object.keys(this.airportParams).map(key => key + '=' + this.airportParams[key]).join('&');
				await this.airportLocationService.INDRAGetAirports(airportString).toPromise().then(
					(result: INDRABFMAirportsResponse) => {
						if (result) {
							this.places = [];
							for (let k = 0; k < result.airports.length; k++) {
								const place = {
									'label': result.airports[k].cityName
								};
								this.places.push(place);
							}
						}
					});
				this.places = this.places.length > 5 ? this.places.slice(0, this.display_limit) : this.places;
				const country = {
					'label': this.regions[regionIdx].countries[j].name,
					'places': this.places
				};

				if (this.places.length === 0) {
					this.display_limit = this.display_limit - 1;
				} else {
					this.countries.push(country);
				}

				while (this.display_limit == this.countries.length) {
					this.countries = this.countries.length > 5 ? this.countries.slice(0, this.display_limit) : this.countries;
					this.airportsPerCountry = this.countries;
					this.loading = false;
					this.display_limit = 5;
					return this.airportsPerCountry;
				}

			}
		}


	}

	INDRA_setPutDestination(event) {
		this.loading = true;
		this.selected_destinations = event;
		this.INDRA_getCountrysDestinations();
	}
}



